import { ExclamationOutlined } from '@ant-design/icons';
import { Descriptions, Tag } from 'antd';
import dayjs from 'dayjs';
import { IWork } from 'models';
import { useMemo } from 'react';
import { userStore } from 'stores';
import { formatPhoneNumber, trucksS } from 'utils';
import { getWorkNumber } from 'utils/get-work-number';

const { Item } = Descriptions;

const TripleSign = () => (
	<>
		<ExclamationOutlined style={{ color: 'red' }} />
		<ExclamationOutlined style={{ color: 'red' }} />
	</>
);

interface WorkInfoForForemenProps {
  work: IWork;
}

export const WorkInfoForForemen = ({ work }: WorkInfoForForemenProps) => {
	const {
		acf: { date, customer_info, foreman_info }
	} = work;
	const payment =
    customer_info.payment === 'cash'
    	? `$${customer_info.result} (cash) / $${
    		+customer_info.result + 10
    	} (card)`
    	: `$${
    		Number(customer_info.result) - 10
    	} (cash) / $${+customer_info.result} (card)`;

	const addresses = useMemo(
		() =>
			new Map([
				['Pick up', customer_info.pickup_address],
				['Drop off', customer_info.dropoff_address]
			]),
		[customer_info.dropoff_address, customer_info.pickup_address]
	);
	return (
		<Descriptions column={1} size="small" title={`Work ${getWorkNumber(work)}`} bordered>
			<Item label="Date">{dayjs(date).format('MM/DD/YYYY')}</Item>
			<Item label="Time">{customer_info.time}</Item>
			<Item label="Movers">{customer_info.movers}</Item>
			<Item label="Rate">{payment}</Item>
			<Item label="Service Fee">${customer_info.truck_fee}</Item>
			{work.acf.paid && (
				<Item label="Deposit">${work.acf.deposit}</Item>
			)}
			<Item label="Move size">{customer_info.bedroom}</Item>
			{!!foreman_info.notes && (
				<Item label="Notes">
					<TripleSign />
					{foreman_info.notes}
					<TripleSign />
				</Item>
			)}
			{Array.from(addresses, ([key, value]) =>
				value?.map((el, index) => (
					<Item label={`${key} ${index + 1}`}>
						<a
							rel="noreferrer"
							target="_blank"
							href={`https://maps.google.com/?q=${el.full_address}`}
						>
							{el.full_address}
							{el.unit !== '' && `, ${el.unit}`}, {el.zip}
						</a>
					</Item>
				))
			)}
			<Item label="Packing">{customer_info.packing}</Item>
			{customer_info.supplies === 'yes' && (
				<Item label="Supplies">
					{customer_info.small_boxes &&
            `Small boxes: ${customer_info.small_boxes}. `}
					{customer_info.medium_boxes &&
            `Medium boxes: ${customer_info.medium_boxes}. `}
					{customer_info.wrapping_paper &&
            `Wrapping paper: ${customer_info.wrapping_paper}. `}
				</Item>
			)}
			<Item label="Customer">{customer_info.customer_name}</Item>
			<Item label="Phone">
				<a href={`tel:${customer_info.customer_phone}`}>
					{formatPhoneNumber(customer_info.customer_phone)}
				</a>
			</Item>
			{customer_info.heavyItems !== 'No' && (
				<Item label="Heavy items">{customer_info.heavyItems}</Item>
			)}
			{!!foreman_info?.workers?.length && (
				<Item label="Helpers">
					{foreman_info?.workers?.map(
						(el, idx) =>
							el?.worker_role === 'helper' && el?.worker && (
								<Tag color="blue" key={idx}>
									{userStore.getUser(el?.worker)?.name}
								</Tag>
							)
					)}
				</Item>
			)}
			{foreman_info.truck.length > 0 && (
				<Item label="Truck Numbers">
					{foreman_info.truck.map((el, idx) => (
						<Tag color="purple" key={idx}>
							{trucksS.find(truck => truck.value === el)?.label}
						</Tag>
					))}
				</Item>
			)}
			<Item label="Truck">
				{customer_info.truck === 'No truck just a labor' ? (
					<Tag color="red">No Truck</Tag>
				) : (
					<Tag color="purple">{customer_info.truck}</Tag>
				)}		
			</Item>

			{customer_info.note && (
				<Item label="Customer Notes">
					<TripleSign />
					{customer_info.note}
					<TripleSign />
				</Item>
			)}
		</Descriptions>
	);
};
